(() => {
  const form = document.querySelector('[data-predictive-search]');
  if (!form) return;
  const input = form.querySelector('input[type=search]');
  const results = form.querySelector('[data-predictive-results]');
  let controller;
  const search = async () => {
    const query = input.value.trim();
    if (query.length < 2) { results.innerHTML = ''; return; }
    controller?.abort(); controller = new AbortController();
    const params = new URLSearchParams({ q: query, 'resources[type]': 'product,collection,page,article', 'resources[limit]': '8', section_id: 'predictive-search' });
    try {
      const html = await fetch(`${window.theme.routes.predictiveSearch}?${params}`, { signal: controller.signal }).then((response) => response.text());
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      results.innerHTML = parsed.querySelector('[data-predictive-results]')?.innerHTML || '';
    } catch (error) { if (error.name !== 'AbortError') results.innerHTML = ''; }
  };
  let timeout;
  input.addEventListener('input', () => { clearTimeout(timeout); timeout = setTimeout(search, 220); });
})();
